import { IAddOnsAppState } from "..";
import AddOnsApi from "../../common/add-on-api";
import { receivePerformanceDetail, failedReserveUpdate, performanceUnavailable, removeAllPerformanceFromRequest,removePerformanceFromRequest, displayLoading } from "./add-ons.actions";
import { IReserveRequest } from "../../../add-ons/classes/add-ons";
//import { processPackageRequest, processPackageRequestError } from "./add-ons.actions";

export function processAddons() {
    return (dispatch, getState: () => IAddOnsAppState) => {
        const state = getState();

        //dispatch loading screen
        dispatch(displayLoading(true));

        let request = new Array<IReserveRequest>();
        if (!state.addOnsText.seatedAddon) {
            state.addOns.reserveRequests.forEach((req) => {
                if (req.zoneId > 0) {
                    req.priceTypeQuantity.forEach((quantity, pt) => {
                        let reserveRequests: IReserveRequest = {
                            performanceId: req.performanceId,
                            zoneId: req.zoneId,
                            priceType: pt,
                            quantity: quantity,
                            priceTypeQuantity: req.priceTypeQuantity,
                            total: req.total
                        }
                        request.push(reserveRequests);
                    });
                }
            });
        } else {
            request = state.addOns.reserveRequests;
        }

        return AddOnsApi.processAddons(request, state.addOnsText.seatedAddon, state.addOnsText.configId)
            .then(apiResult => {
                if (apiResult.success && apiResult.redirectUrl != null) {
                    window.location = apiResult.redirectUrl;
                } else {
                    dispatch(failedReserveUpdate(apiResult.failedPerformance));
                    (apiResult.failedPerformance as number[]).forEach((perfId: number) => {
                        dispatch(removeAllPerformanceFromRequest())
                        dispatch(displayLoading(false));
                    })
                }
            }).catch(error => {
                dispatch(displayLoading(false));
                // If API fails error handling
            });
    }
}

export function getPerformancePricing(performanceId: number) {
    return (dispatch, getState: () => IAddOnsAppState) => {
        return AddOnsApi.getPerformancePricingApi(performanceId, getState().addOnsText.availablePriceTypes).then(apiResult => {
            if (!getState().addOns.processing) {
                //dispatch(displayLoading(true));
            }

            if (apiResult.pricing.zonesAvailable && apiResult.pricing.priceTypeDetails.length> 0) {
                dispatch(receivePerformanceDetail(apiResult))
            }
            else {
                dispatch(performanceUnavailable(apiResult.performanceId))
            }
        }).catch(error => {
            dispatch(performanceUnavailable(performanceId))
        })
    }
}
